import Vue from 'vue'
import io from 'socket.io-client'

let ws = io('http://www.dongyingminsu.com:3002')
ws.on('connect', () => {
    console.log('已连接');
})
ws.on('disconnect', () => {
    console.log('已断开');
});


Vue.prototype.$ws = ws;

